import axios from 'axios'
import ActivityModel from '@/Modules/Activity/ActivityModel.js'

export default class BaseActivityService {
  static resource = null

  static list(modelId, { parameters, filters }) {
    return axios.get(`/${ this.resource }/${ modelId }/activities${ filters }`, { params: parameters, excludeLoader: true })
  }

  static create(modelId, payload) {
    return axios.post(`/${ this.resource }/${ modelId }/activities`, payload)
  }

  static update(modelId, activityId, payload) {
    return axios.put(`/${ this.resource }/${ modelId }/activities/${ activityId }`, payload)
  }

  static updateReminder(modelId, activityId, payload) {
    return axios.put(`/${ this.resource }/${ modelId }/activities/${ activityId }/update-reminder`, payload)
  }

  static updateStatus(modelId, activityId, payload) {
    return axios
      .put(`/${ this.resource }/${ modelId }/activities/${ activityId }/update-status`, payload)
      .then(response => new ActivityModel(response.data.data))
  }

  static delete(modelId, activityId) {
    return axios.delete(`/${ this.resource }/${ modelId }/activities/${ activityId }`)
  }

  static show(modelId, id) {
    return axios
      .get(`${ this.resource }/${ modelId }/activities/${ id }`)
      .then(response => new ActivityModel(response.data.data))
  }
}
